import { useCallback, useMemo, useState } from 'react'

/**
 * رندرِ تدریجیِ فهرست‌های بلند (برای موبایل):
 * به‌جای رندرِ هزاران ردیف یک‌جا، ابتدا `step` ردیف نمایش داده می‌شود و
 * با «نمایشِ بیشتر» (یا رسیدنِ اسکرول به انتها) گروه‌های بعدی اضافه می‌شوند.
 *
 * usage:
 *   const { visible, hasMore, loadMore, total } = useIncrementalList(rows, { step: 50 })
 */
export function useIncrementalList(rows, { step = 50, resetKey = null } = {}) {
  const list = useMemo(() => (Array.isArray(rows) ? rows : []), [rows])
  const [count, setCount] = useState(() => Math.min(step, list.length))

  // با تغییرِ داده یا کلیدِ ریست ⇒ از اول
  const key = resetKey === null ? list.length : resetKey
  const [lastKey, setLastKey] = useState(key)
  if (key !== lastKey) {
    setLastKey(key)
    setCount(Math.min(step, list.length))
  }

  const loadMore = useCallback(() => {
    setCount((c) => Math.min(list.length, c + step))
  }, [list.length, step])

  const visible = useMemo(() => list.slice(0, count), [list, count])

  return {
    visible,
    total: list.length,
    hasMore: count < list.length,
    loadMore,
    remaining: Math.max(0, list.length - count),
  }
}

/** دکمهٔ «نمایشِ بیشتر» با تعدادِ باقی‌مانده — ظاهرِ یکدست با بقیهٔ سامانه */
export function LoadMoreButton({ hasMore, remaining, onClick, label = 'نمایشِ بیشتر' }) {
  if (!hasMore) return null
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 4px' }}>
      <button
        type="button"
        onClick={onClick}
        style={{
          background: '#8fa8f8',
          color: '#fff',
          border: 'none',
          borderRadius: 999,
          padding: '8px 22px',
          fontSize: 13,
          fontWeight: 'bold',
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        {label}
        {remaining ? ` (${remaining.toLocaleString('fa-IR')} مورد دیگر)` : ''}
      </button>
    </div>
  )
}
